import React from "react";

export const BusinessPlan = () => (
  <>
    <div className="hero">
      <h1>Business Plan</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column is-one-quarter fadeLeftMini"></div>
        <div className="column fadeLeftMini">
          <p>
            <span className="fire">MMCC® | Mobile Mint Car Care</span> launched mid-2023 
            as a premium zero-carbon waterless automotive care service. Operating 
            across Surrey & Greater London with services ranging £25-£330, targeting 
            environmentally conscious consumers and B2B partnerships.
          </p>
          <p>
            Current Business Status: 18-month operational track record with 
            established major retail partnership (under NDA), automotive dealer 
            relationships, and active negotiations with leading fuel retailer. 
            Revenue streams include waterless car wash, ceramic coating, mobile 
            ozone odour removal (£50+), and fleet services. Over 1034 cars 
            serviced demonstrating proven market demand.
          </p>
          <p>
            Investment Requirement: Seeking capital to scale operations, 
            expand service capacity, and capitalize on secured partnerships. 
            Business model validated through existing contracts with potential 
            for significant growth through B2B expansion.
          </p>
          <button
            className="button is-pulled-right btn"
            title="Business Plan"
            onClick={(event) => (window.location.href = "/BusinessExecutive")}
          >
            <span>Business Plan</span>
          </button>
        </div>
        <div className="column is-one-quarter fadeLeftMini"></div>
      </div>
    </section>
  </>
);
